import React from "react";
import {
  Box,
  Heading,
  Link,
  List,
  ListItem,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

function scrollToBlogSection(e) {
  e.preventDefault();
  const el = document.getElementById("blog-section");
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
    window.history.replaceState(null, '', '#blog-section');
  } else {
    window.location.href = "/blog#blog-section";
  }
}

export default function AvoidHiddenFees() {
  return (
    <Box maxW="1000px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 20, md: 32 }}>
      <VStack spacing={6} align="start">
        <Link
          as="button"
          onClick={scrollToBlogSection}
          aria-label="Back to Blog"
          position="fixed"
          top={{ base: "84px", md: "96px" }}
          left={{ base: 4, md: 8 }}
          zIndex="sticky"
          bg="white"
          color="teal.600"
          fontWeight="semibold"
          border="1px solid"
          borderColor="teal.100"
          borderRadius="full"
          px={{ base: 0, sm: 4 }}
          py={{ base: 0, sm: 2 }}
          w={{ base: "42px", sm: "auto" }}
          h={{ base: "42px", sm: "auto" }}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="sm"
          _hover={{ textDecoration: "none", bg: "teal.50" }}
        >
          <Text as="span" display={{ base: "inline", sm: "none" }}>←</Text>
          <Text as="span" display={{ base: "none", sm: "inline" }}>← Back to Blog</Text>
        </Link>

        <Heading as="h1" size="xl" mb={2} mt={16}>How to Avoid Hidden Fees in Loans</Heading>
        <Text fontSize="sm" color="gray.500">
          By Heavenly • March 09, 2026 • 5 mins read
        </Text>

        <Text>
          Hidden fees can turn an affordable-looking loan into an expensive one. The safest approach is to compare
          full repayment cost before acceptance.
        </Text>

        <Heading as="h2" size="md">Where Loan Fees Commonly Hide</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Setup or processing fees added at disbursement</ListItem>
          <ListItem>Administration fees charged monthly</ListItem>
          <ListItem>Late or NSF fees that escalate quickly</ListItem>
          <ListItem>Optional add-ons pre-selected by default</ListItem>
        </List>

        <Heading as="h2" size="md">Read These Lines Carefully</Heading>
        <Text>Before you accept, verify:</Text>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Total amount borrowed</ListItem>
          <ListItem>Total amount to repay</ListItem>
          <ListItem>APR and payment frequency</ListItem>
          <ListItem>All conditional fees and penalties</ListItem>
          <ListItem>Prepayment terms (if paying early is allowed)</ListItem>
        </List>

        <Heading as="h2" size="md">Practical Comparison Method</Heading>
        <Text>
          Put two offers side by side and compare only four numbers: amount borrowed, term, total repayment, and total
          fees. This removes marketing noise and shows the true cost quickly.
        </Text>

        <Heading as="h2" size="md">Questions to Ask Support</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Are there any fees not included in the quote I see now?</ListItem>
          <ListItem>What is the exact fee if a payment fails?</ListItem>
          <ListItem>Can I change my payment date?</ListItem>
          <ListItem>Can I repay early without penalty?</ListItem>
        </List>

        <Heading as="h2" size="md">Simple Borrower Rules</Heading>
        <List spacing={2} pl={4} styleType="disc">
          <ListItem>Never accept a loan with unclear fee wording</ListItem>
          <ListItem>Borrow only what your budget can comfortably service</ListItem>
          <ListItem>Keep buffer funds to avoid NSF charges</ListItem>
          <ListItem>Save your final contract and repayment schedule</ListItem>
        </List>

        <Heading as="h2" size="md">Final Thoughts</Heading>
        <Text>
          Transparency is a major sign of a safe loan experience. If a lender cannot clearly explain total cost and
          penalties, it is safer to pause and compare alternatives.
        </Text>
        <Box mt={10} width="100%" textAlign="center">
          <Heading as="h3" size="md" mb={3} color="teal.700">Get an instant loan now with Swift Credit</Heading>
          <Link as={RouterLink} to="/apply" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <Box as="button" bg="teal.500" color="white" px={8} py={3} borderRadius="md" fontWeight="bold" _hover={{ bg: "teal.600" }}>
              Get a Loan
            </Box>
          </Link>
        </Box>
      </VStack>
    </Box>
  );
}
